$('.mobile-menu-btn').on('change', function (e) {
    $('.toogle-mobile').slideToggle();
});
window.changeWidth(640, null, () => $('.toogle-mobile').css({display: 'block'}));



// WEBPACK FOOTER //
// ./src/includes/blocks/tours/tours-filter/tours-filter.js